import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

import { VideoStatus } from '@modules/media/models/media-video.model';
import { StreamService } from '@modules/shared/services/stream.service';

@Component({
  selector: 'mb-stream-player-error',
  templateUrl: './stream-player-error.component.html',
  styleUrls: ['./stream-player-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class StreamPlayerErrorComponent implements OnInit, OnDestroy {
  private streamService = inject(StreamService);

  @Input() errorText!: string | undefined;
  @Input() streamId!: string;
  @Input() streamStatus!: string;

  @Output() closeStreamPlayer = new EventEmitter<void>();
  @Output() streamErrorData = new EventEmitter<{ errorText: string; showErrorScreen: boolean }>();

  private stopPoll$ = new Subject<boolean>();

  ngOnInit(): void {
    if (this.streamStatus === VideoStatus.LIVE) {
      this.pollForStatus();
    }
  }

  public reloadPlayer(): void {
    this.stopPoll$.next(true);
    this.pollForStatus();
  }

  public closePlayer(): void {
    this.closeStreamPlayer.emit();
  }

  private pollForStatus(): void {
    this.streamService
      .pollPlayerStatusForStream(this.streamId, this.stopPoll$)
      .pipe(takeUntil(this.stopPoll$))
      .subscribe((data) => {
        if (data) {
          const { errorText, showErrorScreen } = data;
          this.streamErrorData.emit({ errorText, showErrorScreen });
        }
      });
  }

  ngOnDestroy(): void {
    this.stopPoll$.next(true);
    this.stopPoll$.complete();
  }
}
